import { useState, useEffect } from 'react';

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // Show reconnection message
        setTimeout(() => setWasOffline(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Additional check with a ping to ensure real connectivity
    const checkRealConnectivity = async () => {
      if (navigator.onLine) {
        try {
          // Try to fetch a small resource to verify real internet connectivity
          const response = await fetch('/favicon.ico', {
            method: 'HEAD',
            cache: 'no-cache',
            timeout: 5000
          });
          setIsOnline(response.ok);
        } catch (error) {
          setIsOnline(false);
          setWasOffline(true);
        }
      }
    };

    // Check connectivity every 30 seconds
    const intervalId = setInterval(checkRealConnectivity, 30000);

    // Initial check
    checkRealConnectivity();

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(intervalId);
    };
  }, [wasOffline]);

  return { isOnline, wasOffline };
};

export default useNetworkStatus;
